<template>
  <div :class="status ? 'tag active': 'tag'" @click="click">{{text}}</div>
</template>

<script>
export default {
  name: "Tag",
  props: {
    text: {
      type: String
    }
  },
  data() {
    return {
      status: false
    };
  },
  methods: {
    click() {
      this.status = !this.status;
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  color: rgba(132, 135, 145, 1);
  border: 1px solid rgba(233, 233, 233, 1);
  padding: 3px 5px;
  cursor: pointer;
  margin: 0px 10px 10px 0;
}

.active {
  background: rgba(51, 51, 51, 1);
  color: white;
}
</style>